import { FC } from "react";
import { ICreatedTemplateData } from "../../models/admin/communicationTemplates/communicatinTemplates";
import { Box, Typography } from "@mui/material";
import CommunicationTemplatesStyles from "./CommunicationTemplatesStyles";
import { formatDate } from "./CommunicationTemplatesList";

interface ITemplateVersionsCardProps {
  versionsData: ICreatedTemplateData;
  handleVersionCardClick: (template: ICreatedTemplateData) => void;
}

const TemplateVersionsCard: FC<ITemplateVersionsCardProps> = ({
  versionsData,
  handleVersionCardClick,
}) => {
  return (
    <Box
      sx={CommunicationTemplatesStyles.templateVersionCard}
      onClick={() => handleVersionCardClick(versionsData)}
    >
      <Typography fontSize="0.9rem">{versionsData?.templateName}</Typography>
      <Typography sx={CommunicationTemplatesStyles?.updatedAtText}>
        {formatDate(versionsData?.modifiedAt || "")}
      </Typography>
      <Typography sx={CommunicationTemplatesStyles?.updatedAtText}>
        {`Version ${versionsData?.version}`}
      </Typography>
    </Box>
  );
};

export default TemplateVersionsCard;
